export enum eRowPresentationStyle {
  header = 'header',
  item = 'item',
}
